




















import Vue from 'vue';
import { Location } from 'vue-router';
import WarRoomAvatar from '@/components/partials/war-room/WarRoomAvatar.vue';
import { getPortfolioPath } from '@/utils/routes';
import ArrowRightIcon from './images/arrow-right.vue.svg';
export default Vue.extend({
  name: 'UserMenuMobileSubMenuUser',
  components: {
    WarRoomAvatar,
    ArrowRightIcon,
  },
  computed: {
    myPortfolioLink(): string {
      return getPortfolioPath(this.$auth.user!.slug as string);
    },
  },
});
